// The tasks of Heute, ordered by date. Each task opens the comparison or the contract file it belongs to.

import type { HeuteTask } from "./mock";

export const mockTasks: ReadonlyArray<HeuteTask> = [
  {
    id: "antwort-reinigung",
    dateISO: "2026-10-04",
    glyph: "answer",
    title: "Antwort von Beispiel Reinigung",
    meta: "Vergleich Treppenhausreinigung 2027",
    then: [{ text: "3 Rückfragen beantwortet, 2 Zellen neu prüfen.", strong: false }],
    action: "answer",
    target: { kind: "vergleich", vergleichId: "treppenhausreinigung-2027" },
  },
  {
    id: "kuendigung-winterdienst",
    dateISO: "2026-10-13",
    glyph: "clock",
    title: "Kündigungsfrist Winterdienst",
    meta: "WEG Musterstraße 12, Vertrag Winterdienst",
    then: [
      { text: "Sonst verlängert sich der Vertrag um 12 Monate und bindet ", strong: false },
      { text: "4.165,00 €", strong: true },
      { text: " brutto.", strong: false },
    ],
    action: "deadline",
    target: { kind: "vertrag", vertragId: "winterdienst" },
  },
  {
    id: "preiserhoehung-garten",
    dateISO: "2026-10-20",
    glyph: "increase",
    title: "Preiserhöhung Gartenpflege",
    meta: "Schreiben vom 15.09.2026, Beispiel Grünpflege",
    then: [
      { text: "Gefordert ", strong: false },
      { text: "242,00 €", strong: true },
      { text: " statt 220,00 € netto je Monat.", strong: false },
    ],
    action: "letter",
    target: { kind: "vertrag", vertragId: "gartenpflege" },
  },
];
